import { useEffect, useState } from 'react';

import '../styles/pinPage.css'
import { CgProfile } from "react-icons/cg";
import { MdOutlineClear } from "react-icons/md";
import { FaCheck } from "react-icons/fa6";
import { IoBackspace } from "react-icons/io5";
import { InfinitySpin } from 'react-loader-spinner'

const PinConfirm = ({ setFormData, formData, setPinPopUp, isLoading, err }) => {

  const initialState = {
    pinA: ``, pinB: ``, pinC: ``, pinD: ``, pin: ``

  }

  const [pinData, setPinData] = useState(initialState);

  const FillPin = (digt) => {
    if (pinData.pinA === ``) {
      setPinData({ ...pinData, pinA: digt })
    } else if (pinData.pinA !== `` && pinData.pinB === ``) {
      setPinData({ ...pinData, pinB: digt })
    } else if (pinData.pinA !== `` && pinData.pinB !== `` && pinData.pinC === ``) {
      setPinData({ ...pinData, pinC: digt })
    } else if (pinData.pinA !== `` && pinData.pinB !== `` && pinData.pinC !== `` && pinData.pinD === ``) {
      setPinData({ ...pinData, pinD: digt })
    }
  }

  let pin = `${pinData.pinA}${pinData.pinB}${pinData.pinC}${pinData.pinD}`


  const clear = () => {
    setPinData({ pinA: ``, pinB: ``, pinC: ``, pinD: ``, pin: `` })
  }

  useEffect(() => {
    setFormData({ ...formData, pin: pin })
    console.log(pin)
  }, [pin])

  console.log(pinData)
  console.log(pin)

  return (
    <>
      <div className="pinPage">
        {
          !isLoading ?
            <>
              <div className="ppCont">
                <div className="hder">
                  <CgProfile />
                  <h2>Verify Your Identity</h2>
                  <p>Please enter your secure 4-digit Pin to continue</p>
                </div>
                <div className="pinInput">
                  <div className="pins">
                    <p className="bullets"> {pinData.pinA} </p>
                    <p className="bullets"> {pinData.pinB} </p>
                    <p className="bullets"> {pinData.pinC} </p>
                    <p className="bullets"> {pinData.pinD} </p>
                  </div>
                  <ul>
                    <li onClick={(e) => { FillPin(`1`) }}><p>1</p></li>
                    <li onClick={(e) => { FillPin(`2`) }}><p>2</p></li>
                    <li onClick={(e) => { FillPin(`3`) }}><p>3</p></li>
                    <li onClick={(e) => { FillPin(`4`) }}><p>4</p></li>
                    <li onClick={(e) => { FillPin(`5`) }}><p>5</p></li>
                    <li onClick={(e) => { FillPin(`6`) }}><p>6</p></li>
                    <li onClick={(e) => { FillPin(`7`) }}><p>7</p></li>
                    <li onClick={(e) => { FillPin(`8`) }}><p>8</p></li>
                    <li onClick={(e) => { FillPin(`9`) }}><p>9</p></li>
                    <li onClick={(e) => { clear() }}><p><IoBackspace /></p></li>
                    <li onClick={(e) => { FillPin(`0`) }}><p>0</p></li>
                    <li><button type="submit"><FaCheck /></button></li>
                  </ul>
                </div>
                <div className="cancel" onClick={(e) => { setPinPopUp(false) }}>
                  <MdOutlineClear />
                </div>
              </div>
            </> :
            <>
              <div className="loadi">
                <InfinitySpin
                  width="200"
                  color="#1e222d"
                  />
                  <h4>Verifying Identity...</h4>
                  <p>{err}</p>
              </div>
            </>
        }
      </div>
    </>
  )
}

export default PinConfirm